import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { transformation, images } from "../content/site";
import { FadeUp } from "./Reveal";

export default function Transformation() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgScale = useTransform(scrollYProgress, [0, 1], [1.1, 1]);
  const imgY = useTransform(scrollYProgress, [0, 1], ["-5%", "5%"]);

  return (
    <section id="vision" ref={ref} data-testid="section-transformation" className="relative bg-cream pt-10 pb-20 sm:pt-14 sm:pb-28">
      {/* nav anchor for "Laundry Lounge" */}
      <span id="lounge" className="absolute -top-20" aria-hidden="true" />

      <div className="container-edge">
        <div className="mx-auto max-w-4xl text-center">
          <FadeUp delay={0.1}>
            <h2 className="font-serif text-4xl leading-[1.04] tracking-tight text-navy sm:text-5xl lg:text-6xl">
              {transformation.headline}
            </h2>
          </FadeUp>
          <FadeUp delay={0.2}>
            <p className="mx-auto mt-8 max-w-2xl font-sans text-base font-light leading-relaxed text-navy/70 sm:text-lg">
              {transformation.body}
            </p>
          </FadeUp>
        </div>

        <FadeUp delay={0.1} y={60} className="mt-16">
          <div className="relative overflow-hidden">
            <motion.img
              src={images.transformation}
              alt="The Laundry Lounge interior — navy alcove, warm wood, coffee bar and lounge seating"
              loading="lazy"
              style={{ scale: imgScale, y: imgY }}
              className="aspect-[16/9] w-full object-cover"
            />
            <div className="pointer-events-none absolute inset-0 ring-1 ring-inset ring-navy/10" />
          </div>
        </FadeUp>

        <FadeUp delay={0.15} className="mx-auto mt-16 max-w-3xl">
          <blockquote className="border-l-2 border-brass pl-6 sm:pl-8">
            <p className="font-serif text-2xl italic leading-snug text-navy sm:text-3xl">
              &ldquo;{transformation.quote}&rdquo;
            </p>
          </blockquote>
        </FadeUp>
      </div>
    </section>
  );
}
